import Header from "./components/Header";
import Hero from "./components/Hero";
import BreakingFeed from "./components/BreakingFeed";
import ReversalSection from "./components/ReversalSection";
import FaceSlapSection from "./components/FaceSlapSection";
import FactCheckSection from "./components/FactCheckSection";
import EvidenceSection from "./components/EvidenceSection";
import FollowUpSection from "./components/FollowUpSection";
import CtaBand from "./components/CtaBand";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-background-50 font-sans">
      <Header />
      <main>
        <Hero />
        <BreakingFeed />
        <ReversalSection />
        <FaceSlapSection />
        <FactCheckSection />
        <EvidenceSection />
        <FollowUpSection />
        <CtaBand />
      </main>
      <Footer />
    </div>
  );
}